import { render, staticRenderFns } from "./medkitlogForm.vue?vue&type=template&id=6c90ec12"
import script from "./medkitlogForm.vue?vue&type=script&lang=js"
export * from "./medkitlogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports